module.exports = __webpack_public_path__ + "651d85ff7c76e83ce2da80ad5782630d.pdf";